<div
  class="toast"
  [class.toast-success]="toastPackage.toastType === 'success'"
  [class.toast-error]="toastPackage.toastType === 'error'"
  [class.toast-info]="toastPackage.toastType === 'info'"
  [class.toast-warning]="toastPackage.toastType === 'warning'"
>
  <div
    tabindex="0"
    #toastContent
    class="toast-message"
    [attr.role]="toastRole"
    [attr.aria-label]="toastPackage.message"
  >
    <span aria-hidden="true" [innerHTML]="toastPackage.message"></span>
  </div>
  <div class="toast-top">
    <button aria-hidden="true" type="button" class="toast-close-button" aria-label="Close toast" (click)="remove()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
